import { Application } from "@hotwired/stimulus";

// We decided to use https://stimulus.hotwired.dev/ to write js code
// as it provides a great way to structure and develop js components.
import PageMenu from "./Fusion/Presentation/Components/PageMenu/PageMenu";
import ServiceMenu from "./Fusion/Presentation/Components/ServiceMenu/ServiceMenu";
import LanguageMenu from "./Fusion/Presentation/Components/LanguageMenu/LanguageMenu";
import Slider from "./Fusion/Presentation/Components/Slider/Slider";

declare global {
    interface Window {
        Stimulus: any;
        ErrorTrackingSystem: any;
    }
}

const Stimulus = Application.start();
// we decided to add controllers manually as we want to use our own folder structure
// for ts/js
Stimulus.register("PageMenu", PageMenu);
Stimulus.register("ServiceMenu", ServiceMenu);
Stimulus.register("Slider", Slider);
Stimulus.register("LanguageMenu", LanguageMenu);

// enable if needed
// Stimulus.debug = true;
window.Stimulus = Stimulus;
